import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import moment from 'moment-timezone';
import { Button, Col, Row } from 'reactstrap';
import PageContentLayout from 'components/PageContentLayout';
import { showLoader, showMessage, userSignOutSuccess, handleHTTPError } from 'store/actions';
import { searchClubEvents } from 'apis';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Constants } from 'utils/constants';
import { downloadCSV } from 'utils';

class EventsReportDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            from: '',
            to: '',
            club: null,
            events: [],
        };
    }

    componentDidMount() {
        this.fetchEventReport();
    }

    fetchEventReport = async () => {
        try {
            const query = queryString.parse(this.props.location.search);
            const from = query?.from ?? moment().startOf('month').format('YYYY-MM-DD');
            const to = query?.to ?? moment().endOf('month').format('YYYY-MM-DD');
            const params = {
                club: this.props.match.params.id,
                stDate: moment(from).format('YYYY-MM-DD'),
                etDate: moment(to).format('YYYY-MM-DD'),
                'isFree.ne': true,
            };
            this.props.showLoader(true);
            const { data } = await searchClubEvents(params);
            const events = data
                .map((x) => {
                    const regUsers = x.regUsers.filter(
                        (v) =>
                            v.status === Constants.CLUBEVENT_REGUSER_STATUS.REGISTERED &&
                            !v.isWaitList &&
                            (x.isClubCharge || v.paymentIntentId)
                    );
                    return { ...x, regUsers };
                })
                .filter((x) => x.regUsers.length > 0);
            let club;
            if (events.length > 0) club = events[0].club;
            this.setState({ from, to, events, club });
        } catch (error) {
            this.props.handleHTTPError(error);
        } finally {
            this.props.showLoader(false);
        }
    };

    downloadReport = () => {
        let csvDatas = [];
        this.state.events.forEach((event, index) => {
            event.regUsers.forEach((regUser, rIndex) => {
                if (rIndex === 0)
                    csvDatas.push({
                        No: index + 1,
                        'Date Time': event.start,
                        'Event Title': event.title,
                        Attendees: regUser.user?.fullName,
                        'Payment Type': event.isClubCharge ? 'Club Charge' : 'Online Pay',
                        Amount: event.isClubCharge ? event.price : regUser.paidAmount,
                    });
                else
                    csvDatas.push({
                        No: '',
                        'Date Time': '',
                        'Event Title': '',
                        Attendees: regUser.user?.fullName,
                        'Payment Type': event.isClubCharge ? 'Club Charge' : 'Online Pay',
                        Amount: event.isClubCharge ? event.price : regUser.paidAmount,
                    });
            });
        });
        downloadCSV(csvDatas, `${this.state.club.displayName}_Event Report (${this.state.from}~${this.state.to})`);
    };

    render() {
        if (this.state.events.length === 0) return null;

        const generateBody = () => {
            return this.state.events.map((x, index) => {
                return x.regUsers.map((v, uIndex) => {
                    if (uIndex === 0)
                        return (
                            <tr key={`${index}${uIndex}`}>
                                <td rowSpan={x.regUsers.length}>{index + 1}</td>
                                <td rowSpan={x.regUsers.length}>{x.start}</td>
                                <td rowSpan={x.regUsers.length}>{x.title}</td>
                                <td>{v.user.fullName}</td>
                                <td>{x.isClubCharge ? 'Club Charge' : 'Online Pay'}</td>
                                <td>$ {x.isClubCharge ? x.price : v.paidAmount}</td>
                            </tr>
                        );
                    else
                        return (
                            <tr key={`${index}${uIndex}`}>
                                <td>{v.user.fullName}</td>
                                <td>{x.isClubCharge ? 'Club Charge' : 'Online Pay'}</td>
                                <td>$ {x.isClubCharge ? x.price : v.paidAmount}</td>
                            </tr>
                        );
                });
            });
        };

        return (
            <PageContentLayout title="Event Report Details">
                <Row>
                    <Col md={4}>
                        <p>
                            <span>Club: </span>
                            <span className=" font-weight-bold">{this.state.club.displayName}</span>
                        </p>
                        <p>
                            <span>Total: </span>
                            <span className=" font-weight-bold">
                                $&nbsp;
                                {this.state.events.reduce(
                                    (sum, x) =>
                                        (sum += x.regUsers.reduce(
                                            (acc, v) => (acc += x.isClubCharge ? x.price : v.paidAmount),
                                            0
                                        )),
                                    0
                                )}
                            </span>
                        </p>
                    </Col>
                    <Col md={4}>
                        <p>
                            <span>From: </span>
                            <span className=" font-weight-bold">{this.state.from}</span>
                        </p>
                        <p>
                            <span>To: </span>
                            <span className=" font-weight-bold">{this.state.to}</span>
                        </p>
                    </Col>
                    <Col md={4} className="d-flex justify-content-end align-items-center">
                        <Button color="primary" size="lg" onClick={this.downloadReport}>
                            <FontAwesomeIcon icon="download" /> Download
                        </Button>
                    </Col>
                    <Col md={12}>
                        <table className="table table-bordered">
                            <thead className="bg-primary text-white">
                                <tr>
                                    <th>No</th>
                                    <th>Date Time</th>
                                    <th>Event Title</th>
                                    <th>Attendees</th>
                                    <th>Payment Type</th>
                                    <th>Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.events.length === 0 && (
                                    <tr>
                                        <td colSpan="8" className="text-danger text-center">
                                            No Data
                                        </td>
                                    </tr>
                                )}
                                {generateBody()}
                            </tbody>
                        </table>
                    </Col>
                </Row>
            </PageContentLayout>
        );
    }
}

const mapStateToProps = ({ user, ui }) => {
    const { authUser } = user;
    const { isLoader } = ui;
    return { authUser, isLoader };
};
export default withRouter(
    connect(mapStateToProps, {
        showLoader,
        showMessage,
        userSignOutSuccess,
        handleHTTPError,
    })(EventsReportDetails)
);
